/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const EdgeInput = zod.object({
  edgeDescription: zod
    .string()
    .nullish()
    .describe(
      'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
    ),
  edgeKey: zod
    .string()
    .nullish()
    .describe(
      'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
    ),
  from: zod
    .string()
    .min(1)
    .optional()
    .describe(
      'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
    ),
  max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
  min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
  position: zod.int().nullish(),
  to: zod
    .string()
    .min(1)
    .describe(
      'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
    ),
});

export type EdgeInput = zod.input<typeof EdgeInput>;
export type EdgeInputOutput = zod.output<typeof EdgeInput>;
